import Model from '@fahrirusliyadi/vuejs-model'
import dayjs from 'dayjs'
import User from './User'

/* eslint-disable accessor-pairs */

export default class Comment extends Model {
  get $attributes() {
    return [
      'id',
      'user_id',
      'commentable_id',
      'commentable_type',
      'parent_id',
      'comment',
      'is_anonymous',
      'is_admin',
      'is_max_comment',
      'created_at',
      'updated_at',
      'replies',
      'user',
      'onReply',
    ]
  }

  set user(user) {
    this.$set('user', user && new User(user))
  }

  set replies(replies) {
    replies = replies?.map((attrs) => new Comment(attrs))
    this.$set('replies', replies)
  }

  get createdAt() {
    return dayjs(this.created_at)
  }

  set onReply(onReply) {
    this.$set('onReply', onReply)
  }
}
